import { WeekDays } from 'shared/enums/news';

export const ALL_WEEK_DAYS: WeekDays[] = [
  WeekDays.SUNDAY,
  WeekDays.MONDAY,
  WeekDays.TUESDAY,
  WeekDays.WEDNESDAY,
  WeekDays.THURSDAY,
  WeekDays.FRIDAY,
  WeekDays.SUTURDAY,
  WeekDays.EVERY_DAY_CHECKBOX,
];
